import script from "./HandoverStatusBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./HandoverStatusBadge.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__